import React from "react";
import { Sparkles } from "lucide-react";
import { OfficerBadge } from "../AIOfficers";

export const DemoCtaView = ({ officer, onBack }) => (
  <div className="p-6 flex flex-col items-center text-center flex-1" data-testid="floating-dock-demo-cta">
    <OfficerBadge officer={officer} active size="lg" />
    <h3 className="text-base font-bold text-white mt-4 leading-tight">{officer?.name}</h3>
    <p className="text-xs text-gray-400 mt-2 leading-relaxed">
      {officer?.specialty}
    </p>
    <div className="mt-6 p-4 rounded-xl bg-gradient-to-br from-purple-500/[0.08] to-pink-500/[0.05] border border-purple-500/20 w-full">
      <Sparkles className="w-5 h-5 text-purple-300 mx-auto mb-2" />
      <p className="text-xs text-white font-semibold leading-tight">Crea cuenta gratis para consultar este AI Officer</p>
      <p className="text-[11px] text-gray-400 mt-2 leading-relaxed">
        Acceso completo a los 6 officers especializados, contexto en vivo y reportes ejecutivos.
      </p>
      <a
        href="/auth"
        className="mt-4 inline-flex items-center justify-center w-full px-4 py-2.5 rounded-xl bg-gradient-to-br from-purple-600 to-pink-600 text-white text-xs font-semibold hover:opacity-90 transition-opacity"
        data-testid="floating-dock-signup-cta"
      >
        Crear cuenta gratis
      </a>
      <button
        onClick={onBack}
        className="mt-2 text-[11px] text-gray-500 hover:text-gray-300 transition-colors"
      >
        Ver otros officers
      </button>
    </div>
  </div>
);
